"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isMarketingContactsSKUSelector = exports.merchandiseEditionSelector = exports.merchUnitTypeSelector = exports.baseMerchForAdditionalUnitSelector = exports.getMerchIdForEditionSelector = exports.merchandiseSelector = void 0;

var _reselect = require("reselect");

var _SubscriptionTermSelectors = require("./SubscriptionTermSelectors");

var _Hubs = require("self-service-api/constants/Hubs");

var _Editions = require("self-service-api/constants/Editions");

var _MerchandiseIds = require("self-service-api/constants/MerchandiseIds");

var _HubMap = _interopRequireDefault(require("self-service-api/constants/HubMap"));

var _MarketingContactsSelectors = require("pricing-pages-unified-ui/selectors/MarketingContactsSelectors");

var _UnitTypes = require("pricing-pages-unified-ui/constants/UnitTypes");

var merchandiseSelector = function merchandiseSelector(_ref) {
  var merchandise = _ref.merchandise;
  return merchandise;
};

exports.merchandiseSelector = merchandiseSelector;
var getMerchIdForEditionSelector = (0, _reselect.createSelector)(_SubscriptionTermSelectors.subscriptionTermsSelector, merchandiseSelector, _MarketingContactsSelectors.isInMCBetaSelector, function (subscriptionTerms, merchandiseMap, isInMCBeta) {
  return function (hub, edition) {
    var isMarketingStarter = hub === _Hubs.HUB_MARKETING && edition === _Editions.STARTER;
    var isLegacyMarketingStarter250Portal = !!subscriptionTerms[_MerchandiseIds.PRODUCT_MARKETING_STARTER_EMAIL];

    if (isMarketingStarter && isLegacyMarketingStarter250Portal && !isInMCBeta) {
      return _MerchandiseIds.PRODUCT_MARKETING_STARTER_EMAIL;
    }

    var highlightedMerchToUse = isInMCBeta && hub === _Hubs.HUB_MARKETING ? _HubMap.default[hub].highlightedPaidMerchMCBeta : _HubMap.default[hub].highlightedPaidMerch;
    var merchIdForEdition = highlightedMerchToUse.find(function (merchId) {
      return merchandiseMap[merchId].edition === edition;
    });
    return merchIdForEdition;
  };
});
exports.getMerchIdForEditionSelector = getMerchIdForEditionSelector;

var baseMerchForAdditionalUnitSelector = function baseMerchForAdditionalUnitSelector(state, merchandiseId) {
  var merchandiseMap = merchandiseSelector(state);
  return Object.values(merchandiseMap).find(function (merchItem) {
    return merchItem.additionalUnitMerchId === merchandiseId;
  }) || null;
};

exports.baseMerchForAdditionalUnitSelector = baseMerchForAdditionalUnitSelector;

var merchUnitTypeSelector = function merchUnitTypeSelector(state, merchId) {
  var merchandiseMap = merchandiseSelector(state);
  if (!merchandiseMap) return null;
  var _merchandiseMap$merch = merchandiseMap[merchId],
      additionalUnitMerchId = _merchandiseMap$merch.additionalUnitMerchId,
      units = _merchandiseMap$merch.units;
  if (units) return units;
  return merchandiseMap[additionalUnitMerchId].units;
};

exports.merchUnitTypeSelector = merchUnitTypeSelector;

var merchandiseEditionSelector = function merchandiseEditionSelector(state, merchandiseId) {
  var merchandiseMap = merchandiseSelector(state);

  if (merchandiseMap[merchandiseId]) {
    return merchandiseMap[merchandiseId].edition;
  }

  return null;
};

exports.merchandiseEditionSelector = merchandiseEditionSelector;

var isMarketingContactsSKUSelector = function isMarketingContactsSKUSelector(state, merchId) {
  var merchandiseMap = merchandiseSelector(state);
  if (!merchandiseMap || !merchandiseMap[merchId]) return null;
  var _merchandiseMap$merch2 = merchandiseMap[merchId],
      additionalUnitMerchId = _merchandiseMap$merch2.additionalUnitMerchId,
      units = _merchandiseMap$merch2.units;

  if (units) {
    return units === _UnitTypes.MARKETING_CONTACT;
  }

  if (!merchandiseMap[additionalUnitMerchId]) return null;
  return merchandiseMap[additionalUnitMerchId].units === _UnitTypes.MARKETING_CONTACT;
};

exports.isMarketingContactsSKUSelector = isMarketingContactsSKUSelector;